import { Component, OnInit } from "@angular/core";
import { News } from "src/app/base/news-post/model/news.model";
import { FileLoaderService } from "src/app/services/file-loader.service";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.scss"],
})
export class NewsComponent implements OnInit {
  news: Array<News> = [];

  constructor(private fileLoader: FileLoaderService) {}

  ngOnInit(): void {
    console.log("itt");
    this.loadNews();
  }

  loadNews() {
    console.log("itt");
    this.fileLoader.getNews().subscribe((news) => {
      debugger;
      this.news = news;
    });
  }
}
